import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class LessonService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  types() {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}lessons/types`).toPromise();
  }

  search(params: {
    query?: string,
    filters?: any
  }) {
    return this.http.post(`${this.toolsSrv.getApiTargetEndpoint()}lessons/dashboard`, params).toPromise();
  }

  download(uniqid) {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}lessons/download/${uniqid}`).toPromise();
  }

}
